import { render, staticRenderFns } from "./qcOrderDetail2022.vue?vue&type=template&id=68cbfe2c&"
import script from "./qcOrderDetail2022.vue?vue&type=script&lang=js&"
export * from "./qcOrderDetail2022.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports